import App from './components/App'
export default App

window.updateAvailable.then(update => {
  if (window.confirm('An new version of Wiip is available. Would you like to update and reload now?')) {
    update()
  }
})
